import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import { CustomFieldsEditorModalComponent } from 'media/components/customFieldsEditorModal.component'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class EditCustomFieldsOp extends BaseOperation {
  icon = 'far fa-list'
  showInSelectionToolbar = true
  showInContextMenu = true
  supportsMultiple = true
  supportsDirs = true
  supportsBundles = true
  triggersReload = true
  weight = -1

  constructor (
    private ngbModal: NgbModal,
    private translate: TranslateService,
  ) {
    super()
    this.label = translate.instant('Custom fields')
  }

  isVisibleFor (_input, context) {
    return context.permission?.showCustomFields && context.root?.customFields?.length && context.permission.allowWriteDb
  }

  async run (input, context) {
    const m = this.ngbModal.open(CustomFieldsEditorModalComponent)
    m.componentInstance.root = context.root
    m.componentInstance.dirs = input.dirs
    m.componentInstance.bundles = input.bundles
    await m.result.catch(() => null)
  }
}

MediaOperationsService.register(EditCustomFieldsOp)
